var path = 'app/scripts/modules/core/src/application/modal/applicationProviderFields.component.html';
var html = "<ng-include\n  src=\"template\"\n  ng-repeat=\"template in $ctrl.getRelevantProviderFieldsTemplates()\">\n</ng-include>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/application/modal/applicationProviderFields.component.html
// module id = 950
// module chunks = 0